import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { dispatchSideMenuToggle } from "@/_LayoutsRelated/layoutHooks/useSideMenuController";
import SyarahLogo from "@/components/SyarahLogo/SyarahLogo";
import useNavItemTracker from "../navEvents";
var UnbxdMobileTextSearch = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdMobileTextSearch-UnbxdMobileTextSearch";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdMobileTextSearch-UnbxdMobileTextSearch" */"@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch");
    }
    return eval('require.resolve')("@/components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch");
  }
}, {
  fallback: /*#__PURE__*/React.createElement("div", {
    className: "h-[37px] w-[228px] max-w-full rounded-full border border-solid border-[#e6e9ef]"
  })
});

/**
 * The responsive listing/search header row — Figma 4090:12509.
 *
 * Logo and a 228px search pill sit together at the inline start (8px apart);
 * `justify-between` pushes the hamburger to the far end, leaving the gap the
 * design shows between them. Not a stretched full-width bar.
 *
 * Shared on purpose: search pages hide the layout header (`hideHeaderOnmobile`)
 * and render their own via `MobileFilters` → `SearchHeader`, while other
 * listing routes get it from `MobileHeader`'s `listing` variant. One component
 * so the two can't drift.
 *
 * The pill itself is the search component's `navbar` variant — Figma
 * 4121:23789 — so its dimensions, padding, placeholder and magnifier live
 * there rather than in override classes here.
 */
var MobileListingSearchRow = function MobileListingSearchRow() {
  var _useTranslation = useTranslation(["web_header"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var trackNav = useNavItemTracker("top_navigation");
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-[38px] items-center justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 items-center gap-2"
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/"),
    "aria-label": "Syarah home",
    id: "mobile-nav-logo",
    "data-id": "mobile-nav-logo",
    onClick: function onClick() {
      return trackNav("logo");
    },
    className: "shrink-0"
  }, /*#__PURE__*/React.createElement(SyarahLogo, {
    width: 57,
    height: 38,
    className: "hasEvents"
  })), /*#__PURE__*/React.createElement(UnbxdMobileTextSearch, {
    referral_location: "listing",
    variant: "navbar"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "mobile-nav-menu",
    "data-id": "mobile-nav-menu",
    "aria-label": t("menu", {
      ns: "web_header"
    }),
    onClick: function onClick() {
      trackNav("hamburger_menu");
      dispatchSideMenuToggle();
    },
    className: "inline-flex size-6 shrink-0 items-center justify-center border-0 bg-transparent p-0 text-navy-primary"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "iconify material-symbols--menu-rounded",
    style: {
      width: 24,
      height: 24
    }
  })));
};
export default MobileListingSearchRow;